<template>
  <div class="omni-chat no-print">
    <div class="omni-chat__button" @click="setOpenChat">
      <transition name="scaleIn" mode="out-in">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon-chat-group-alt tw-icon--small"
             v-if="!isShowChat" key="chatClosed">
          <rect width="16" height="13" x="2" y="2" class="secondary" rx="2"/>
          <path class="primary"
                d="M6 16V8c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v13a1 1 0 0 1-1.7.7L16.58 18H8a2 2 0 0 1-2-2z"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" v-else viewBox="0 0 24 24" class="tw-icon--small icon-close"
             key="chatOpen">
          <path class="primary" fill-rule="evenodd"
                d="M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"/>
        </svg>
      </transition>
    </div>
    <transition name="chatFadeIn">
      <div class="omni-chat__container" v-if="isShowChat">
        <div>
          <div class="omni-chat__container__header">
            <div class="omni-chat__logo">
              <span class="icon-docendo"></span>
            </div>
            <h1>Hej 👋</h1>
            <p>Vi er dit Docendo-team. Vi står klar til at svare på dine spørgsmål :)</p>
          </div>
          <div class="omni-chat__container__body">
            <div class="omni-chat__container__body__box">
              <h4>Skriv en email eller ring til os</h4>
              <div class="customer-support__imgs">
                <img :src="anne"
                     content="Anne"
                     v-tippy="{
                    arrow: true,
                    placement : 'bottom',
                    zIndex: 2147483010
                  }">
                <img :src="henrik"
                     content="Henrik"
                     v-tippy="{
                    arrow: true,
                    placement : 'bottom',
                    zIndex: 2147483010
                  }">
                <img :src="jeppe"
                     content="Jeppe"
                     v-tippy="{
                    arrow: true,
                    placement : 'bottom',
                    zIndex: 2147483010
                  }">
              </div>
              <br>
              <ul class="support-options">
                <li><span class="icon-question3"></span> <a target="_blank" href="https://help.docendo.dk/da">Se supportforum</a></li>
                <li><span class="icon-envelop"></span> <a target="_blank" href="mailto:kontakt@docendo.dk">kontakt@docendo.dk</a></li>
                <li><span class="icon-phone2"></span> +45 43 31 06 12</li>
              </ul>
              <a target="_blank" href="mailto:kontakt@docendo.dk?subject=Supporthenvendelse" class="bttn bttn--primary bttn--primary--chat">Send os en email</a>
              <p class="text-explainer">Chatsupport vender snart tilbage. Du kan altid sende os en email eller ringe, hvis du har spørgsmål.</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import imgAnne from '../../assets/img/staff/anne.jpeg'
import imgHenrik from '../../assets/img/staff/henrik.jpeg'
import imgJeppe from '../../assets/img/staff/jeppe.jpeg'
export default {
  data () {
    return {
      isShowChat: false,
      anne: imgAnne,
      henrik: imgHenrik,
      jeppe: imgJeppe
    }
  },
  methods: {
    setOpenChat () {
      this.isShowChat = !this.isShowChat
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.omni-chat__button {
  position: fixed;
  z-index: 2147483003;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #468AD7;
  cursor: pointer;
  box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%);
  /* animation: chat-app-launcher 250ms ease; */
  transition: transform 0.25s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.omni-chat__button:active {
  transform: scale(0.98);
}

@keyframes chat-app-launcher {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.tw-icon--small {
  width: 32px;
}

.tw-icon--small .primary {
  fill: #ffffff;
}

.tw-icon--small .secondary {
  fill: rgba(255, 255, 255, 0.5)
}

.omni-chat__container {
  z-index: 2147483000;
  position: fixed;
  bottom: 100px;
  right: 20px;
  height: calc(100vh - 120px);
  width: 376px;
  min-height: 250px;
  max-height: 704px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;
  opacity: 1;
  border-radius: 8px;
  overflow: hidden;
  transition: width 200ms ease 0s, height ease 0s, max-height ease 0s;
  background: #ffffff;
}

.chatFadeIn-enter-active, .chatFadeIn-leave-active {
  transition: opacity .15s, transform 0.15s;
}

.chatFadeIn-enter, .chatFadeIn-leave-to {
  transform: translateY(1rem);
  opacity: 0;
}

.omni-chat__container__header {
  height: 200px;
  padding: 2rem;
  background: linear-gradient(135deg, rgb(139, 183, 232) 0%, rgb(54, 130, 215) 100%);
}

.omni-chat__logo {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: var(--blue);
  font-size: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: height 160ms ease-out 0s;
}

.scaleIn-enter-active, .scaleIn-leave-active {
  transition: transform 0.15s;
}

.scaleIn-enter, .scaleIn-leave-active {
  opacity: 0;
  transform: scale(0.5);
}

.omni-chat__container__body {
  padding: 2rem;
  position: relative;
}

.omni-chat__container__body__box {
  background: #ffffff;
  position: absolute;
  top: calc(-2rem + 1rem);
  left: 2rem;
  width: calc(100% - 4rem);
  padding: 1rem;
  box-shadow: rgb(0 0 0 / 10%) 0px 4px 15px 0px, rgb(0 0 0 / 10%) 0px 1px 2px 0px, rgb(70 138 215 / 50%) 0px 2px 0px 0px inset;
  border-radius: 0.25rem;
  animation: 0.25s ease 0s normal forwards 1 chat-app-container;
  transition: transform 0.25s;
}

@keyframes chat-app-container {
  0% { opacity:0; transform: translateY(1rem)}
  66% { opacity:0; transform: translateY(1rem)}
  100% { opacity:1; transform: translateY(0)}
}


h1 {
  color: #ffffff;
  font-weight: lighter;
}

.omni-chat__container__header p {
  color: rgba(255, 255, 255, 0.7);
  font-weight: lighter;
  font-size: 16px;
}

.customer-support__imgs {
  display: flex;
  align-items: center;
  margin-top: 1rem;
}

.customer-support__imgs img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-right: -0.75rem;
  box-shadow: 0px 0px 2px black;
}

.bttn.bttn--primary.bttn--primary--chat {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
}
.support-options {
  font-size: 1rem;
}

.support-options li {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.support-options li > span {
  font-size: 14px;
  margin-right: 1rem;
}

.support-options li a:hover {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// HelpIcon.vue?6af3fb7d